import z from 'zod';

const get = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      part_number: z.string(),
      description: z.string().optional().default(''),
      normalized_code: z.string().optional(),
      normalized_match_key: z.string().optional(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};

const getSchema = z.object(get);
export type Get = z.infer<typeof getSchema>;
